import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../../utils/content.util';
import { hasPermission, Permission } from '../../models/role.model';
import { AwsCognitoUser } from '../../models/user.model';

interface PermissionRouteProps {
  children: React.ReactNode;
  permission: Permission | Permission[];
}

export default function PermissionRoute({ children, permission }: PermissionRouteProps) {
  const { pathname, search } = useLocation();
  const { isAuthenticated, currentUser } = useAppContext();

  // First check authentication
  if (!isAuthenticated) {
    return <Navigate to={`/login?redirect=${pathname}${search}`} />;
  }

  // Then check permissions
  if (!currentUser) {
    return <Navigate to="/dashboard" />;
  }

  // Handle single permission or array of permissions (OR logic)
  const permissions = Array.isArray(permission) ? permission : [permission];
  const hasRequiredPermission = permissions.some((perm) => hasPermission(currentUser as AwsCognitoUser, perm));

  if (!hasRequiredPermission) {
    return <Navigate to="/dashboard" />;
  }

  return <div className="admin-section">{children}</div>;
}

